@if (section(); as s) {
  <app-section-wrapper [id]="s.id" [title]="s.title">
    <div class="psr-grid stagger">
      @for (card of s.items; track card.problem) {
        <div class="psr-card">
          <div class="psr-flow">
            <div class="psr-item psr-item--problem">
              <span class="psr-label">Probléma</span>
              <p>{{ card.problem }}</p>
            </div>
            <div class="psr-item psr-item--solution">
              <span class="psr-label">Megoldás</span>
              <p>{{ card.solution }}</p>
            </div>
            <div class="psr-item psr-item--result">
              <span class="psr-label">Eredmény</span>
              <p>{{ card.result }}</p>
            </div>
          </div>
        </div>
      }
    </div>
  </app-section-wrapper>
}
